import { useState } from "react";
import TokenDebouncer from "../utils/TokenPostDebouncer";
import Debouncer from "../utils/TokenPostDebouncer";

export const KarmaPoolCauseManager = (local, setLocal, parentRefresh, getURLBasePath) => {

    const subscribeToCause = (cause) => {
        fetchCause(cause);
    }

    function refresh() {
        for (let i = 0; i < local.causes.length; i++) {
            const cause = local.causes[i];
            cause.loading = false;
            fetchCause(cause["name"]);
        }
    }

    const [tokenDebouncer, setTokenDebouncer] = useState(() => ({
        debouncer: new TokenDebouncer()
    }));

    function addTokenToCause(causeName, tokens) {

        if (local.user.tokensAllocatedToCycle + tokens < 0 ||
            local.user.tokensAllocatedToCycle + tokens > local.user.tokens) {
            return;
        }

        let gbpPerToken = local.cycle.gbpInCycle / (local.cycle.totalTokensAllocated + tokens);

        if (local.cycle.totalTokensAllocated + tokens == 0) {
            gbpPerToken = local.cycle.gbpInCycle;
        }

        console.log("1234 gbp in cycle: " + local.cycle.gbpInCycle + "");
        console.log("1234 total tokens allocated: " + local.cycle.totalTokensAllocated + "");

        console.log("gbp per token is: " + gbpPerToken + "");

        let causesCopy = local.causes;

        let totalTokens = 0;

        for (let i = 0; i < causesCopy.length; i++) {
            const c = causesCopy[i];

            if (c["name"] === causeName) {
                c["tokensAllocatedToCycleByUser"] += tokens;
                c["tokensAllocatedToCycleTotal"] += tokens;
                totalTokens = c["tokensAllocatedToCycleByUser"];
            }

            c["gbpRaisedToCycleByUser"] = gbpPerToken * (c["tokensAllocatedToCycleByUser"]);
            c["gbpRaisedToCycleTotal"] = gbpPerToken * (c["tokensAllocatedToCycleTotal"]);

            // gbp raised to 2.dp
            c["gbpRaisedToCycleByUser"] = Math.round(c["gbpRaisedToCycleByUser"] * 100) / 100;
            c["gbpRaisedToCycleTotal"] = Math.round(c["gbpRaisedToCycleTotal"] * 100) / 100;

            console.log("1234 gbp per token: " + gbpPerToken + "");
            console.log("1234 gbp raised to cycle by user: " + c["gbpRaisedToCycleByUser"] + "");

            setLocal(prevValue => {
                return { ...prevValue, causes: causesCopy };
            });
        }

        setLocal(prevValue => {
            return {
                ...prevValue,
                user: { ...prevValue.user, "tokensAllocatedToCycle": prevValue.user.tokensAllocatedToCycle + tokens }
            };
        });

        setLocal(prevValue => {
            return {
                ...prevValue,
                cycle: {
                    ...prevValue.cycle,
                    "totalTokensAllocated": prevValue.cycle.totalTokensAllocated + tokens,
                    "gbpPerToken": prevValue.cycle.gbpInCycle / (prevValue.cycle.totalTokensAllocated + tokens)
                }
            };
        });

        // Debounce 1 second
        tokenDebouncer.debouncer.debounce(causeName, totalTokens, addTokenToCausePOST, 500);

        return {};
    }

    function addTokenToCausePOST(causeName, tokensToAdd) {
        fetch(getURLBasePath() + 'tokenAllocation', {
            method: 'POST',
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                "causeId": getCause(causeName)["id"],
                "cycleId": local.cycle["id"],
                "userId": local.user["id"],
                "tokensAllocated": tokensToAdd
            })
        })
            .then((response) => response.json())
            .then((data) => {
                //parentRefresh();
                console.log(data);

            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function getCause(causeName) {
        for (let i = 0; i < local.causes.length; i++) {
            const c = local.causes[i];

            if (c["name"] === causeName) {
                return c;
            }
        }

        return {};
    }

    function fetchCause(causeName) {
        let causeLoading = getCause(causeName);

        if (causeLoading !== undefined && causeLoading !== null)
        {
            if (causeLoading.loading !== undefined && causeLoading.loading)
            {
                return;
            }

            causeLoading.loading = true;
            updateCauseInLocal(causeLoading);
        }

        fetch(getURLBasePath() + 'cause/' + causeName, {
            headers: new Headers({
                'Authorization': window.localStorage.getItem("jwtAuthToken"),
                'Content-Type': 'application/json'
            })
        })
            .then((response) => response.json())
            .then((data) => {
                data.loading = false;
                console.log(data);
                updateCauseInLocal(data)
            })
            .catch((err) => {
                console.log(err.message);
            });
    }

    function updateCauseInLocal(updatedCause) {
        setLocal(prevValue => {
            let newCauses = prevValue.causes;

            let replaced = false;
            for (let i = 0; i < newCauses.length; i++) {
                const cause = newCauses[i];
                if (cause["name"] === updatedCause["name"]) {
                    newCauses[i] = updatedCause;
                    replaced = true;
                    break;
                }
            }

            if (!replaced) {
                newCauses.push(updatedCause);
            }

            return { ...prevValue, causes: newCauses };
        });
    }

    return {
        refresh: refresh,
        getCause: getCause,
        subscribeToCause: subscribeToCause,
        addTokenToCause: addTokenToCause
    };
}